import {Component} from '@angular/core';

@Component({
  selector: 'id37-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent {
}
